import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DiscordIcon(props: IconProps) {
    return <Icon {...props} iconKey={"discord"}/>
}
